// @flow
import styled from "styled-components";
import { fontBold } from "@fdr/static-ui//Typography";
import buildColor from "@fdr/static-ui//ColorPalette";

export const TrackStateWrapper = styled.div`
  margin-right: 8px;
`;

export const ResultedTrackStateWrapper = styled.div`
  margin-right: 8px;

  & > div > span {
    color: ${buildColor("grey", "800")};
  }
`;

export const TrackInfo = styled.div`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-left: 16px;
`;

export const FavoriteIconWrapper = styled.button`
  width: 16px;
  height: 24px;
  padding: 0;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  outline: none;
  cursor: pointer;
`;

export const TrackName = styled.span`
  display: flex;
  align-items: center;
  flex-grow: 1;
  color: ${buildColor("grey", "D4")};
  font-family: ${fontBold};
  font-weight: 500;
  font-size: 14px;
  height: 17px;

  > :first-child {
    width: 100%;
  }
`;
